// =====================================================================
// ❄️ FROZEN MODE ❄️
// While `true`, the site renders normally but ALL background cloud
// activity is disabled: no Supabase fetches, no realtime subscriptions,
// no coupon lookups, no Razorpay orders. CTAs route through the
// "Access Temporarily Paused" modal. Set to `false` to resume.
// =====================================================================
export const FROZEN_MODE = false;

export const FROZEN_PAUSED_MESSAGE =
  "New user access is temporarily paused. We will reopen soon. Stay tuned.";
